import { createContext, useContext } from "react"

export const CampaignWizardContext = createContext("campaignWizard")

export const useCampaignWizardContext = () => useContext(CampaignWizardContext)
